import React, { Fragment, useEffect, useRef, useState } from 'react';
import closeButton from '../assets/images/Vector 32.svg';
import arrowUp from '../assets/images/arrow-up.svg';
import arrowDown from '../assets/images/arrow-down.svg';
import Correct from '../assets/images/green-circle.svg';
import YellowCircle from '../assets/images/yellow-circle.svg';
import Incorrect from '../assets/images/red-circle.svg';
import Incomplete from '../assets/images/incomplete-circle.svg';
import Inprogress from '../assets/images/Inprogress.svg';
import Submitted from '../assets/images/submitted-circle.svg';
import ArrowBack from '../assets/images/chevrons-left.svg';
import RightsidebarGreybox from '../components/RightsidebarGreybox';
import { useLocation, useNavigate } from 'react-router-dom';
import haye from '../assets/images/model/haye.png';

import 'react-quill/dist/quill.snow.css';

import { canAttempt, formatDate as dateFormat } from '../utils';

const CompleteActivityDuetoNext = ({
  setComplteDueNext,
  setClosing,
  activitiesByAssignedDate,
  mode,
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [openActivities, setOpenActivities] = useState({});

  const [openedDate, setOpenedDate] = useState(localStorage.getItem('openedDate'));
  const handleCloseSidebar = () => {
    setClosing(true); // Trigger closing animation first
    setTimeout(() => {
      setComplteDueNext(false); // Remove after animation completes
      setClosing(false);
    }, 300); // Match CSS transition duration (300ms)
  };

  const getCorrectImage = (activity) => {
    const { percentage, status } = calculateAveragePercentage(activity.activityAnswers);

    if (
      activity.activityAnswers.length &&
      activity?.activityAnswers?.[0]?.isGraded &&
      percentage >= 0 &&
      percentage <= 69
    ) {
      return Incorrect;
    } else if (
      activity.activityAnswers.length &&
      activity?.activityAnswers?.[0]?.isGraded &&
      percentage >= 70 &&
      percentage <= 99
    ) {
      return YellowCircle;
    } else if (percentage === 100 && activity?.activityAnswers?.[0]?.isGraded) {
      return Correct;
    } else if (
      !activity?.activityAnswers?.[0]?.isGraded &&
      activity?.activityAnswers?.[0]?.activityStatus === 'InProgress' &&
      activity?.activityAnswers?.[0]?.answers.length
    ) {
      return Inprogress; // New "InProgress" image
    } else if (
      !activity?.activityAnswers?.[0]?.isGraded &&
      activity?.activityAnswers?.[0]?.answers.length
    ) {
      return Submitted;
    } else if (activity.activityAnswers.filter((answer) => !answer.answers.length).length) {
      return Incomplete;
    }
  };

  const calculateAveragePercentage = (activityAnswers) => {
    if (!activityAnswers || !activityAnswers.length) {
      return {
        status: 'Incomplete',
        percentage: 0,
        totalCorrectAnswers: 0,
        totalIncorrectAnswers: 0,
        activityAnswers,
      };
    }
    const { grade, activityStatus, isGraded } = activityAnswers[0];

    const totalCorrectAnswers = activityAnswers
      .map((activityAnswer) =>
        (activityAnswer.answers || []).filter(
          (nestedAnswer) =>
            nestedAnswer.isGraded && nestedAnswer.isCorrect && nestedAnswer.givenMarks
        )
      )
      .flat().length;

    const totalIncorrectAnswers = activityAnswers
      .map((activityAnswer) =>
        (activityAnswer.answers || []).filter(
          (nestedAnswer) =>
            nestedAnswer.isGraded && !nestedAnswer.isCorrect && !nestedAnswer.givenMarks
        )
      )
      .flat().length;

    const totalAnswers = activityAnswers.reduce(
      (acc, curr) => acc + (curr.answers ? curr.answers.length : 0),
      0
    );

    const totalGradedAnswers = activityAnswers
      .map((activityAnswer) =>
        (activityAnswer.answers || []).filter((nestedAnswer) => nestedAnswer.isGraded)
      )
      .flat().length;

    if (totalAnswers === 0) {
      return { status: 'Incomplete' };
    }

    if (!isGraded && activityStatus === 'InProgress' && totalAnswers > 0) {
      return { status: 'InProgress' };
    }

    if (totalGradedAnswers === 0) {
      return { status: 'Submitted' };
    }

    const percentage = grade;

    return {
      status: isGraded ? 'Completed' : 'Submitted',
      percentage: Math.round(percentage),
      totalCorrectAnswers,
      totalIncorrectAnswers,
      activityAnswers,
    };
  };
  const InProgressState = (activity) => {
    const totalAnswers = activity?.activityAnswers.reduce((acc, curr) => {
      if (curr.answers && curr.answers.length > 0) {
        // Regular expression to match empty HTML tags like <p><br></p>
        const emptyHtmlTagsPattern =
          /^(<p><br><\/p>|<p><\/p>|<br>|<div><\/div>|<span><\/span>|\s*)$/;

        // Filter answers based on type and criteria
        const validAnswersCount = curr.answers.filter((ans) => {
          if (ans.type === 'fr' || ans.type === 'sa' || ans.type === 'blanks') {
            // Check if answerText is not empty and doesn't match the empty HTML tag pattern
            return ans.answerText?.trim() !== '' && !emptyHtmlTagsPattern.test(ans.answerText);
          } else if (ans.type === 'mcqs' || ans.type === 'truefalse') {
            // Check if answerIndex is valid (not equal to -1) for "mcqs" and "truefalse" types
            return ans.answerIndex !== -1;
          }
          return false; // Exclude other types if they exist
        }).length;

        return acc + validAnswersCount;
      }
      return acc;
    }, 0);

    const totalQuestions = activity?.questions?.length;
    return {
      totalQuestions,
      totalAnswers,
    };
  };

  const handleToggle = (index, date) => {
    const clickedDate = new Date(date.assignedDate).setHours(0, 0, 0, 0);

    setOpenActivities((prevState) => {
      const updatedActivities = {
        ...prevState,
        [index]: prevState[index] !== undefined ? !prevState[index] : true, // Toggle or initialize as true
      };

      // Reset all activities to false if the clicked date matches the opened date
      if (clickedDate == openedDate) {
        Object.keys(updatedActivities).forEach((key) => {
          updatedActivities[key] = false;
        });
        setOpenedDate(null); // Clear the openedDate
      }

      return updatedActivities;
    });
  };
  useEffect(() => {
    if (activitiesByAssignedDate.length > 0) {
      const sortedActivities = [...activitiesByAssignedDate]
        .sort((a, b) => new Date(a.assignedDate) - new Date(b.assignedDate))
        .filter(
          (assign) =>
            new Date(assign.assignedDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
        );

      if (sortedActivities.length > 0) {
        const firstDateKey = sortedActivities[0].assignedDate;
        const firstDateObj = new Date(firstDateKey).setHours(0, 0, 0, 0);

        setOpenActivities((prevState) => ({
          ...prevState,
          [firstDateKey]: true,
        }));

        setOpenedDate(firstDateObj);
        localStorage.setItem('openedDate', firstDateObj);
      }
    }
  }, [activitiesByAssignedDate]);

  const upcomingGroups = [...activitiesByAssignedDate]
    .sort((a, b) => new Date(a.assignedDate) - new Date(b.assignedDate))
    // keep only dates >= today
    .filter(
      (group) =>
        new Date(group.assignedDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
    );

  // Now check if any group has activities and whether canAttempt or any criteria to show
  const hasUpcoming = upcomingGroups.some(
    (group) => Array.isArray(group.activities) && group.activities.length > 0
    // optionally further filter by canAttempt or other conditions if needed
  );

  return (
    <div
      className={`focuse-mode-right-side `}
      style={{ height: 'calc(-72px + 100vh)', display: 'flex' }}
    >
      <div style={{ position: 'relative', width: 'calc(100% - 24px)' }}>
        {mode === 'std-book' ? (
          <div
            className='focuse-mode-close-button'
            onClick={() => {
              setComplteDueNext(false);

              localStorage.removeItem('openedDate');
            }}
          >
            <img src={closeButton} className='close-button-top' alt='' />
            <div className='close-button-txt'>Close</div>
          </div>
        ) : (
          <div style={{ height: '24px' }}></div>
        )}

        <div
          className='focuse-mode-right-side-child mt-0'
          style={{ overflowY: 'scroll', position: 'relative' }}
        >
          {hasUpcoming ? (
            <>
              {upcomingGroups.map((group) => {
                // Determine if this group is open
                const groupKey = group._id || group.assignedDate;
                const isOpenGroup =
                  openActivities[group.assignedDate] ||
                  new Date(group.assignedDate).setHours(0, 0, 0, 0) === openedDate;

                return (
                  <div key={groupKey} className='activity-of-months'>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div
                        className='activity-next mb-0'
                        style={{ paddingBottom: '4px', cursor: 'pointer' }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleToggle(group.assignedDate, group);
                        }}
                      >
                        Activities Due {dateFormat(group.assignedDate)}{' '}
                        <img
                          src={openActivities[group.assignedDate] ? arrowUp : arrowDown}
                          className='padding-left'
                          alt=''
                        />
                      </div>
                    </div>
                    {isOpenGroup &&
                      Array.isArray(group.activities) &&
                      group.activities.length > 0 &&
                      group.activities.map((obj) => {
                        // existing logic per activity
                        const activityAnswers = obj.activityAnswers || [];
                        const result = calculateAveragePercentage(activityAnswers);
                        const { totalAnswers, totalQuestions } = InProgressState(obj);
                        const shortLongAnswers = activityAnswers[0]?.answers?.filter((answer) =>
                          ['fr', 'sa'].includes(answer.type)
                        );
                        const graded = activityAnswers[0]?.isGraded;

                        const getPercentageDisplay = () => {
                          if (result.status === 'Incomplete') return 'Incomplete';
                          if (result.status === 'InProgress')
                            return `In Progress | ${totalAnswers} out of ${totalQuestions} answered`;
                          if (result.status === 'Submitted') return 'Submitted';
                          if (result.percentage === 100 && graded)
                            return `${result.percentage}% | ${result.totalCorrectAnswers} correct`;
                          return `${result.percentage}% | ${
                            result.totalCorrectAnswers
                          } correct - ${result.totalIncorrectAnswers} incorrect${
                            shortLongAnswers?.length
                              ? ` | ${
                                  activityAnswers[0]?.answers?.filter((e) => !e.isGraded).length
                                } to be graded`
                              : ''
                          }`;
                        };

                        const getActionButtonLabel = () => {
                          if (result.status === 'Incomplete') return 'Start';
                          if (result.status === 'InProgress') return 'Start';
                          if (result.percentage < 100 && graded) return 'Redo';
                          return 'View';
                        };

                        const objTime = new Date(obj.assignedDate).setHours(0, 0, 0, 0);
                        const isOpen =
                          openActivities[group.assignedDate] || objTime === openedDate;

                        return (
                          isOpen && (
                            <div
                              key={obj._id}
                              className='act_due_m_wrapper'
                              style={{ paddingBottom: '0px' }}
                            >
                              <div className='act_due_left'>
                                <div className='act_mark_as'>
                                  <img
                                    style={{ width: '30px', height: '30px' }}
                                    src={getCorrectImage(obj)}
                                    alt=''
                                  />
                                </div>
                                <div className='act_title_ac'>
                                  <div className='title_ac'>{obj.title}</div>
                                  <div className='quan_ac'>{getPercentageDisplay()}</div>
                                </div>
                              </div>
                              {canAttempt(obj) && (
                                <div
                                  className='act_due_right'
                                  onClick={() => {
                                    if (pathname === '/studentlearn') {
                                      navigate(`/studentfocusedmode/${obj._id}`);
                                    } else if (pathname.includes('/studentfocusedmode')) {
                                      navigate(`/studentfocusedmode/${obj._id}`, {
                                        replace: true,
                                      });
                                      setComplteDueNext(false);
                                    }
                                  }}
                                >
                                  {getActionButtonLabel()}
                                </div>
                              )}
                            </div>
                          )
                        );
                      })}
                  </div>
                );
              })}
              {/* “All caught up” can appear if you want after listing all groups, but since hasUpcoming is true, we skip “no activities” */}
            </>
          ) : (
            // No upcoming activities at all:
            <div
              className='d-flex flex-column align-items-center justify-content-center w-100'
              style={{ padding: '16px' }}
            >
              <span className='no-activity' style={{ fontSize: '20px' }}>
                No activities due next
              </span>
              <img
                style={{ width: '32px', height: '32px', paddingTop: '8px' }}
                src={haye}
                alt='No activities'
              />
            </div>
          )}

          {/* If mode==='focus', you may still want the back arrow regardless */}
          {mode === 'focus' && (
            <div
              style={{
                position: 'absolute',
                right: '28px',
                top: '8px',
                height: '24px',
                cursor: 'pointer',
                textAlign: 'center',
              }}
            >
              <img
                src={ArrowBack}
                style={{ transform: 'rotate(-180deg)' }}
                onClick={(e) => {
                  e.preventDefault();
                  handleCloseSidebar();
                }}
                alt='back-arrow'
              />
            </div>
          )}
        </div>
      </div>
      <RightsidebarGreybox className={'abs_gray_righ_sidebar'} />
    </div>
  );
};

export default CompleteActivityDuetoNext;
